import getScrollAccessor from './getScrollAccessor';
export default getScrollAccessor('pageXOffset');


//////////////////
// WEBPACK FOOTER
// ./~/dom-helpers/esm/scrollLeft.js
// module id = 280
// module chunks = 0